<template>
    <bs5-base-modal title="Edit Distributor" :visible="visible" @close="closeModal">
        <template v-slot:default>
            <form @submit.prevent="updateDistributor">
                <div class="mb-3">
                    <bs5-base-label for="name">Name</bs5-base-label>
                    <bs5-base-input id="name" v-model="distributor.name" required />
                </div>

                <div class="mb-3">
                    <bs5-base-label for="description">Description</bs5-base-label>
                    <bs5-base-input id="description" v-model="distributor.description" />
                </div>
            </form>
        </template>

        <template v-slot:footer>
            <bs5-cancel-button @click="closeModal" />
            <bs5-save-button :loading="saving" @click="updateDistributor" />
        </template>
    </bs5-base-modal>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import distributorService from "@/services/distributor.service";
import { Distributor } from "@/models/distributor.model";
import { showToast } from "@/utils/toast";

export default defineComponent({
    name: "EditDistributorModal",
    props: {
        visible: { type: Boolean, required: true },
        distributorId: { type: String, required: true },
    },
    emits: ["close", "distributor-updated"],
    data() {
        return {
            distributor: ref<Distributor>({ id: "", name: "", description: "" }),
            saving: ref(false),
        };
    },
    watch: {
        distributorId: {
            immediate: true,
            handler(newId) {
                if (newId) this.fetchDistributor();
            },
        },
    },
    methods: {
        async fetchDistributor() {
            try {
                this.distributor = await distributorService.getDistributorById(this.distributorId);
            } catch (error) {
                console.error("Error fetching distributor:", error);
            }
        },
        async updateDistributor() {
            this.saving = true;
            try {
                await distributorService.updateDistributor(this.distributor.id!, this.distributor);
                this.$emit("distributor-updated");
                this.closeModal();
                showToast("Distributor updated!", "success");
            } catch (error) {
                showToast("Failed to update distributor!", "error");
                console.log("error");
            } finally {
                this.saving = false;
            }
        },
        closeModal() {
            this.$emit("close");
        },
    },
});
</script>